import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';

const updateSelectedTrade = (state, action) => ({
  ...state,
  [action.payload.tradeState]: {
    id: action.payload.tradeId,
    isAuctionEnded: false,
    upcomingProxy: null,
    auctionSummary: null,
    isWatchlisted: null
  }
});

const updateSelectedTradeUpcomingProxy = (state, action) => {
  const { tradeState } = action.payload;
  return {
    ...state,
    [tradeState]: {
      ...state[tradeState],
      upcomingProxy: action.payload.upcomingProxy,
      isWatchlisted: true
    }
  };
};

const updateSelectedTradeAuctionSummary = (state, action) => {
  const { tradeState } = action.payload;

  return {
    ...state,
    [tradeState]: {
      ...state[tradeState],
      auctionSummary: action.payload.auctionSummary,
      isWatchlisted: true
    }
  };
};

const updateSelectedTradeIsWatchlisted = (state, action) => {
  const { tradeState } = action.payload;
  return {
    ...state,
    [tradeState]: {
      ...state[tradeState],
      isWatchlisted: action.payload.isWatchlisted
    }
  };
};

const updateSelectedTradeIsAuctionEnded = (state, action) => {
  const { tradeState } = action.payload;
  return {
    ...state,
    [tradeState]: {
      ...state[tradeState],
      isAuctionEnded: action.payload.isAuctionEnded
    }
  };
};

const selectedTrades = createSlice({
  name: 'selectedTrades',
  initialState,
  reducers: {
    updateSelectedTrade,
    updateSelectedTradeUpcomingProxy,
    updateSelectedTradeAuctionSummary,
    updateSelectedTradeIsWatchlisted,
    updateSelectedTradeIsAuctionEnded
  }
});

export default selectedTrades;
